import React from 'react'
import { Block, Card, ThemeVariants, Typography, TypographyTypes } from 'rds'
import Logo from './Logo'

const Suspended = () => {
    return (
        <Block
            variant={ThemeVariants.SECONDARY}
            style={{ height: '100vh', width: '100vw' }}
        >
            <Card className='rds-screen-centered'>
                <div className='rds-flex rds-justify-center'>
                    <Logo />
                </div>
                <div className='rds-m_top__sm rds-text-align_center'>
                    <Typography type={TypographyTypes.H3}>
                        Lo sentimos
                    </Typography>
                    <Typography>
                        No estamos disponibles por el momento.
                        <br />
                        Intenta nuevamente más tarde.
                    </Typography>
                </div>
            </Card>
        </Block>
    )
}

export default Suspended
